import _get from 'lodash/get';

import { localStore, logError, post } from 'utils';
import { STORAGE_KEYS } from 'utils/DICTIONARY';

export default function generateRefreshToken(callback = () => {}) {
  const refreshToken = localStore.get(STORAGE_KEYS.REFRESH_TOKEN);

  if (!refreshToken) {
    return callback(null); // Assume no error and skip further processing
  }

  post({ apiKey: 'auth.refreshToken' }, { params: { refresh: refreshToken } })
    .then(({ data }) => {
      localStore.put(STORAGE_KEYS.REFRESH_TOKEN, _get(data, 'refresh', ''));
      callback(null, data);
    })
    .catch(err => {
      logError(err);
      callback(err, null);
    });
}
